 import ToggleSwitch from "../../toggle-switch/toggle-switch"; 
 import DropDown from "../../drop-down/drop-down";
 
 
 
 export const NormalCell = ({ event , subItemsField , handleSelectionChange ,  handleExpandChange }) => {
  const { dataItem, level } = event;

  if (!dataItem) return null;

  const hasChildren =
    dataItem[subItemsField] &&
    dataItem[subItemsField].length > 0;

  const getLevelDepth = (lvl) => {
    if (Array.isArray(lvl)) return lvl.length;
    return lvl ?? 0;
  };

  const depth = getLevelDepth(level);
  const paddingLeft = depth * 25;

  return (
    <td  onClick={ () =>{ handleSelectionChange( event ) }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft
        }}
      >
      {hasChildren ? (
  <span
    className={`k-icon ${
      dataItem.expanded ? "k-i-caret-alt-down" : "k-i-caret-alt-right"
    }`}
    style={{ cursor: "pointer", marginRight: 6 }}
    onClick={(e) => {
      e.stopPropagation();
      handleExpandChange({ dataItem });
    }}
  />
) : (
  <span style={{ width: 16, marginRight: 6 }} />
)}

        <span style={{ marginRight: 6 }}>
          {dataItem.isFolder ? dataItem.expanded ?  <span class="k-icon k-i-folder-open"></span>  : <span class="k-icon k-i-folder"></span> :<span class="k-icon k-i-file"></span>}
        </span>

        {dataItem.Name}
      </div>
    </td>
  );
};
  

export const ToggleCell = ( { event , subItemsField } ) =>{
     return <td>
          {
             !event.dataItem.isFolder &&
             <div style={
                {width:"40%" , minWidth:"100px"}
             }>
                <ToggleSwitch rightLabel={"No"} leftLabel={"Yes"} size="sm" checked={event.dataItem.Required}/>
             </div>
          }
     </td>
}


export  const DropDownCell = ()=>{
  return <td>
       <DropDown/>
  </td>
}